(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    class CartDrawer {
    constructor() {
      this.drawer = document.getElementById('cart-drawer');
      if (!this.drawer) return;

      this.bindEvents();
    }

    bindEvents() {
      // Open drawer
      document.querySelectorAll('[data-cart-drawer-open]').forEach(trigger => {
        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          this.open();
        });
      });

      // Close drawer
      document.querySelectorAll('[data-cart-drawer-close]').forEach(trigger => {
        trigger.addEventListener('click', () => this.close());
      });

      // Escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen()) {
          this.close();
        }
      });

      // Quantity buttons
      this.drawer.querySelectorAll('[data-qty-change]').forEach(btn => {
        btn.addEventListener('click', (e) => this.handleQuantityChange(e));
      });

      // Quantity input change
      this.drawer.querySelectorAll('.cart-drawer__qty-input').forEach(input => {
        input.addEventListener('change', (e) => this.handleQuantityInput(e));
      });

      // Remove buttons
      this.drawer.querySelectorAll('[data-remove-item]').forEach(btn => {
        btn.addEventListener('click', (e) => this.handleRemove(e));
      });
    }

    isOpen() {
      return this.drawer.getAttribute('aria-hidden') === 'false';
    }

    open() {
      this.drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    close() {
      this.drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    async handleQuantityChange(e) {
      const btn = e.currentTarget;
      const change = parseInt(btn.dataset.qtyChange);
      const key = btn.dataset.itemKey;
      const input = this.drawer.querySelector(`.cart-drawer__qty-input[data-item-key="${key}"]`);
      const newQty = Math.max(0, parseInt(input.value) + change);
      
      input.value = newQty;
      await this.updateItem(key, newQty);
    }

    async handleQuantityInput(e) {
      const input = e.currentTarget;
      const key = input.dataset.itemKey;
      const newQty = Math.max(0, parseInt(input.value) || 0);
      
      await this.updateItem(key, newQty);
    }

    async handleRemove(e) {
      const btn = e.currentTarget;
      const key = btn.dataset.removeItem;
      const item = this.drawer.querySelector(`[data-cart-item="${key}"]`);
      
      if (item) {
        item.classList.add('is-removing');
      }
      
      await this.updateItem(key, 0);
    }

    async updateItem(key, quantity) {
      const item = this.drawer.querySelector(`[data-cart-item="${key}"]`);
      if (item) {
        item.classList.add('is-updating');
      }

      try {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: key,
            quantity: quantity
          })
        });

        if (response.ok) {
          // Refresh the cart drawer content
          await this.refreshDrawer();
          // Update header cart count
          this.updateCartCount();
        }
      } catch (error) {
        console.error('Error updating cart:', error);
        if (item) {
          item.classList.remove('is-updating', 'is-removing');
        }
      }
    }

    async refreshDrawer() {
      try {
        // Fetch the current page HTML to get updated cart-drawer content
        const response = await fetch(window.location.pathname, {
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        });
        const html = await response.text();
        
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newDrawer = doc.getElementById('cart-drawer');
        
        if (newDrawer) {
          const newContent = newDrawer.querySelector('#cart-drawer-content');
          const newTitle = newDrawer.querySelector('.cart-drawer__title');
          
          if (newContent) {
            document.getElementById('cart-drawer-content').innerHTML = newContent.innerHTML;
            // Re-bind events for new content
            this.bindEvents();
          }
          
          if (newTitle) {
            this.drawer.querySelector('.cart-drawer__title').innerHTML = newTitle.innerHTML;
          }
        }
      } catch (error) {
        console.error('Error refreshing cart drawer:', error);
        // Fallback: reload the page
        window.location.reload();
      }
    }

    async updateCartCount() {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        
        const countElements = document.querySelectorAll('.elvee-header__cart-count');
        countElements.forEach(el => {
          if (cart.item_count > 0) {
            el.textContent = cart.item_count;
            el.style.display = '';
          } else {
            el.style.display = 'none';
          }
        });
      } catch (error) {
        console.error('Error updating cart count:', error);
      }
    }
  }

  // Initialize
  document.addEventListener('DOMContentLoaded', () => {
    window.cartDrawer = new CartDrawer();
  });
  } catch(e) { console.error(e); }
})();

})();
